import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';

import {UserImportRepository} from './repositories/user-import.repository';
import {UserImportService} from './services/user-import.service';
import {UserImportRoutingModule} from './user-import-routing.module';
import {UserImportComponent} from './user-import.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    UserImportRoutingModule,
  ],
  declarations: [
    UserImportComponent,
  ],
  providers: [
    UserImportService,
    UserImportRepository,
  ],
})
export class UserImportModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/user/user-import/user-import.module.ts